/**
 * Recettes.
 *
 * `lieu: 'cuisine'` veut dire qu'il faut etre dans la cuisine d'une maison
 * (voir positionCuisine dans shared/sim/batiments.ts). Un plat cuisine rend
 * environ trois fois la faim de ses ingredients bruts, c'est ce qui rend la
 * cuisine interessante.
 */
import type { Recette } from '../types/items.ts'
import { OBJETS } from './objets.ts'

export const RECETTES: readonly Recette[] = [
  {
    id: 'soupe',
    nom: 'Soupe aux petits fruits',
    feminin: true,
    icone: '🍲',
    cout: { baie: 2, fruit: 1 },
    produit: 'soupe',
    quantite: 1,
    lieu: 'cuisine',
  },
  {
    id: 'tarte',
    nom: 'Tarte aux baies',
    feminin: true,
    icone: '🥧',
    cout: { baie: 3, noix_coco: 1 },
    produit: 'tarte',
    quantite: 1,
    lieu: 'cuisine',
  },
  {
    id: 'brochette',
    nom: 'Brochette de poisson',
    feminin: true,
    icone: '🍢',
    cout: { poisson: 2 },
    produit: 'brochette',
    quantite: 1,
    lieu: 'cuisine',
  },
  {
    id: 'fusee',
    nom: 'Fusée',
    feminin: true,
    icone: '🎆',
    cout: { sable: 5, fibre: 2, bois: 1 },
    produit: 'fusee',
    quantite: 1,
    lieu: 'partout',
  },
  {
    id: 'canne',
    nom: 'Canne à pêche',
    feminin: true,
    icone: '🎣',
    // Une tige et du fil: du bois et de la fibre, rien d'autre. C'est moins cher
    // qu'une barque (bois 34, fibre 20) parce que c'est l'inverse d'un but a
    // atteindre — c'est le premier objet a fabriquer, pas le dernier.
    cout: { bois: 8, fibre: 5 },
    produit: 'canne',
    quantite: 1,
    lieu: 'partout',
  },
  {
    id: 'fusee_lot',
    nom: 'Lot de fusées',
    icone: '🎇',
    cout: { sable: 20, fibre: 8, bois: 4, minerai: 1 },
    produit: 'fusee',
    quantite: 5,
    lieu: 'partout',
  },
]

export function recette(id: string): Recette | undefined {
  return RECETTES.find((r) => r.id === id)
}

export const RECETTES_CUISINE: readonly Recette[] = RECETTES.filter((r) => r.lieu === 'cuisine')

export const RECETTES_PARTOUT: readonly Recette[] = RECETTES.filter((r) => r.lieu === 'partout')

/**
 * Ce qui se fabrique depuis le panneau « Construire ».
 *
 * Un outil n'est ni un batiment ni un vehicule: rien ne se pose dans le monde,
 * il tombe dans le sac. Mais c'est LA que le proprietaire est alle chercher sa
 * canne a peche, et c'est une bonne raison: on y va pour se donner un moyen.
 * La regle est la categorie de l'objet produit, pas une liste ecrite a la main,
 * pour qu'ajouter un outil suffise a le faire apparaitre dans le menu.
 */
export const RECETTES_OUTIL: readonly Recette[] = RECETTES.filter((r) => OBJETS[r.produit].categorie === 'outil')
